<template>
  <b-container fluid class="bv-example-row bv-example-row-flex-cols">
    <b-row>
      <b-col cols="auto" align-v="center">
        <b-form-select
          v-model="typeSelectedHandler"
          :options="typeSelectedOptions"
          size="sm"
        />
      </b-col>
      <!--            <b-col cols="auto">-->
      <!--                <datepicker :minimum-view="" />-->
      <!--                <b-button id="popover-date-selector" variant="primary">เลือกวัน</b-button>-->
      <!--                <b-popover-->
      <!--                        target="popover-date-selector"-->
      <!--                        title="เลือกวัน"-->
      <!--                        triggers="focus"-->
      <!--                        placement="bottom"-->
      <!--                >-->
      <!--                    <b-container fluid>-->
      <!--                        <b-row>-->
      <b-col cols="auto" align-v="center" style="margin-top: 0.5rem;">
        <!--                                <b-form-group label="เลือกประเภท">-->
        <!--                                <b-form-group>-->
        <b-row>
          <b-col cols="auto">
            <b-form-radio
              v-model="dateTypeHandler"
              name="date-type-radios"
              value="date"
              >รายวัน</b-form-radio
            >
          </b-col>
          <b-col cols="auto">
            <b-form-radio
              v-model="dateTypeHandler"
              name="date-type-radios"
              value="month"
              >รายเดือน</b-form-radio
            >
          </b-col>
          <b-col cols="auto">
            <b-form-radio
              v-model="dateTypeHandler"
              name="date-type-radios"
              value="year"
              >รายปี</b-form-radio
            >
          </b-col>
        </b-row>

        <!--                                </b-form-group>-->
      </b-col>
      <!--                        </b-row>-->
      <!--                        <b-row>-->
      <b-col cols="auto" align-v="center">
        <b-row>
          <b-form-group label="จาก" label-cols="2">
            <!--            :disabled-dates="fromDateDisableHandler"-->
            <datepicker
              v-model="fromDateHandler"
              :format="dateFormat"
              :input-class="{ 'form-control': true, 'white-background': true }"
              :minimum-view="dateType"
            />
          </b-form-group>
        </b-row>
      </b-col>
      <b-col cols="auto" align-v="center">
        <b-row>
          <b-form-group label="ถึง" label-cols="2">
            <!-- :disabled-dates="toDateDisableHandler" -->
            <datepicker
              v-model="toDateHandler"
              :format="dateFormat"
              :input-class="{ 'form-control': true, 'white-background': true }"
              :minimum-view="dateType"
            />
          </b-form-group>
        </b-row>
      </b-col>
      <!--                        </b-row>-->
      <!--                    </b-container>-->
      <!--                </b-popover>-->
      <!--            </b-col>-->
      <b-col cols="auto" align-v="center">
        <b-form-select
          v-model="filterShowHandler"
          :options="filterShowOptions"
          size="sm"
        />
      </b-col>
      <b-col cols="auto" align-v="center">
        <b-form-checkbox
          id="showGraphValue"
          v-model="showValueHandler"
          style="margin:auto"
          name="showGraphValue"
          :value="true"
          :unchecked-value="false"
        >
          แสดงค่า
        </b-form-checkbox>
      </b-col>
      <b-col cols="auto" align-v="center">
        <b-button variant="warning" @click="filterHandler">แสดง</b-button>
      </b-col>
      <b-col cols="auto" align-v="center">
        <b-button variant="success" @click="reportStatFunctionHandler"
          >ออกรายงาน</b-button
        >
      </b-col>
      <b-col cols="auto" align-v="center">
        <b-button @click="exportExcelHandler">
          ออกรายงาน Excel
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment-timezone";

export default {
  name: "StatFilterComponent",
  components: {
    Datepicker,
  },
  props: {
    exportExcelHandler: {
      type: Function,
      default: () => null,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
    filterHandler: {
      type: Function,
      default: () => null,
    },
    typeSelected: {
      required: true,
    },
    dateType: {
      required: true,
    },
    fromDate: {
      required: true,
    },
    toDate: {
      required: true,
    },
    filterShow: {
      required: true,
    },
    reportStatFunctionHandler: {
      required: true,
    },
  },
  data() {
    return {
      typeSelectedOptions: [
        {
          value: "test",
          text: "ข้อมูลการตรวจ",
        },
        {
          value: "finance",
          text: "ข้อมูลด้านการเงิน",
        },
      ],
      dateFormat: "MMM yyyy",
      filterShowOptions: [
        {
          value: "all",
          text: "แสดงทั้งหมด",
        },
        {
          value: "graph",
          text: "เฉพาะกราฟ",
        },
        {
          value: "table",
          text: "เฉพาะรายละเอียด",
        },
      ],
    };
  },
  computed: {
    showValueHandler: {
      get() {
        return this.showValue;
      },
      set(value) {
        this.$emit("update:showValue", value);
      },
    },
    typeSelectedHandler: {
      get() {
        return this.typeSelected;
      },
      set(value) {
        this.$emit("update:typeSelected", value);
      },
    },
    dateTypeHandler: {
      get() {
        return this.dateType;
      },
      set(value) {
        this.$emit("update:dateType", value);
      },
    },
    fromDateHandler: {
      get() {
        return this.fromDate;
      },
      set(value) {
        this.$emit("update:fromDate", value);
      },
    },
    toDateHandler: {
      get() {
        return this.toDate;
      },
      set(value) {
        this.$emit("update:toDate", value);
      },
    },
    filterShowHandler: {
      get() {
        return this.filterShow;
      },
      set(value) {
        this.$emit("update:filterShow", value);
      },
    },
    toDateDisableHandler() {
      let handler = {
        to: this.fromDateHandler,
      };

      if (this.dateTypeHandler === "month") {
        let date = this.fromDateHandler
          ? new Date(
              moment(this.fromDateHandler)
                .add(12, "months")
                .format("YYYY-MM-DD")
            )
          : "";
        handler = {
          ...handler,
          from: this.fromDate ? date : "",
        };
      } else if (this.dateTypeHandler === "year") {
        let date = this.fromDateHandler
          ? new Date(
              moment(this.fromDateHandler)
                .add(12, "years")
                .format("YYYY-MM-DD")
            )
          : "";
        handler = {
          ...handler,
          from: this.fromDate ? date : "",
        };
      } else if (this.dateTypeHandler === "date") {
        // console.log("fromDateHandler", this.fromDateHandler);
        let date = this.fromDateHandler
          ? new Date(
              moment(this.fromDateHandler)
                .add(7, "days")
                .format("YYYY-MM-DD")
            )
          : "";
        handler = {
          ...handler,
          from: this.fromDateHandler ? date : "",
        };
      }
      return handler;
    },
    fromDateDisableHandler() {
      return {
        from: this.toDateHandler,
      };
    },
  },
  watch: {
    dateTypeHandler(newValue) {
      switch (newValue) {
        case "month":
          this.dateFormat = "MMM yyyy";
          break;
        case "year":
          this.dateFormat = "yyyy";
          break;
        case "date":
          this.dateFormat = "dd MMM yyyy";
          break;
      }
    },
    fromDateHandler(newValue) {
      let fromDate = moment(newValue);
      let toDate = moment(this.toDateHandler);
      if (toDate.diff(fromDate, "days") < 0) {
        this.toDateHandler = this.fromDateHandler;
      }
      // this.toDateHandler = this.fromDateHandler
    },
  },
  methods: {
    filterHandler() {},
  },
  methods: {},
};
</script>

<style>
.white-background {
  background-color: #fff !important;
}
</style>

<style scoped></style>
